module.exports = __webpack_public_path__ + "static/media/240.bc5e60ba.jpg";